import { inject, Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

import { IStepOption, MdMenuPlacement } from 'ngx-ui-tour-md-menu';

import { TourService } from 'ngx-ui-tour-md-menu';
import { TourPatterns } from 'src/app/shared/constants/tour.patterns';
import { ActivatedRoute, Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class TourUiService {
  private readonly tourService = inject(TourService);
  private readonly router = inject(Router);

  private tourStateSubject = new BehaviorSubject<boolean>(false);

  constructor() {}

  startTour(key: keyof typeof TourPatterns.patterns) {
    const steps: IStepOption[] = TourPatterns.patterns[key].tour;

    const filteredSteps = steps.filter((step: any) => {
      const element = document.querySelector(`[tourAnchor="${step.anchorId}"]`);
      return element !== null;
    });

    this.tourService.initialize(filteredSteps, {
      enableBackdrop: true,
      placement: 'auto' as MdMenuPlacement,
      disablePageScrolling: true,
    });

    this.tourService.start();
  }

  public resolveRoutePattern(): boolean {
    const currentUrl = this.router.url;

    const patterns = TourPatterns.patterns;

    for (const patternKey in patterns) {
      const pattern = patterns[patternKey as keyof typeof patterns];
      const routePattern = pattern.routePattern;
      const matched = currentUrl.match(routePattern);
      if (matched) {
        this.startTour(patternKey as keyof typeof TourPatterns.patterns);
      }
    }
    return true;
  }
}
